<template>
  <b-row>
    <b-col sm="3">
      <strong>Additional Materials</strong>
      <div class="mt-2">
        <strong>Example Documents</strong>
        <div class="mt-2">
          <a  target="_blank" :href="baseUrl + '/docs/exampleILA.pdf'">Example Internship Learning Agreement</a>
        </div>
        <div class="mt-2">
          <a class="mt-2" target="_blank" :href="baseUrl + '/docs/exampleTTCourseAgreement.pdf.pdf'">Example Translational Team Course Agreement</a>
        </div>
      </div>
    </b-col>
    <b-col sm="9">
      <b-alert :show="!validAdditionalMaterials.length" variant="warning">
        To complete this portion of the form, you must first select a Type and Category in the Details tab.
      </b-alert>

      <b-form class="form-horizontal">
        <div v-for="additionalMaterial in validAdditionalMaterials" :key="additionalMaterial.additionalMaterialTypeId">
          <b-form-checkbox v-model="opportunityAdditionalMaterials"
                             :value="{additionalMaterialTypeId: additionalMaterial.additionalMaterialTypeId}"
                             checked="true">
            {{ additionalMaterial.name }}
          </b-form-checkbox>
          <p>(Student interaction {{ additionalMaterial.required ? "will be required" : "is optional" }})</p>
        </div>

        <slot name="buttons"></slot>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {};
  },

  props: {
    additionalMaterials: {
      type: Array,
      required: true
    },

    opportunity: {
      type: Object
    }
  },

  watch: {
    opportunity: function() {
      this.opportunityAdditionalMaterials = [];
      var oam = [];
      _.forEach(this.opportunity.opportunityAdditionalMaterials, function(
        opportunityAdditionalMaterial
      ) {
        oam.push({
          additionalMaterialTypeId:
            opportunityAdditionalMaterial.additionalMaterialTypeId
        });
      });
      this.opportunityAdditionalMaterials = oam;

      if (!this.opportunity.opportunityId) {
        this.initializeAdditionalMaterials();
      }
    },
    additionalMaterials: function() {
      if (!this.opportunity.opportunityId) {
        this.initializeAdditionalMaterials();
      }
    },
    validAdditionalMaterials: function() {
      if (!this.opportunity.opportunityId) {
        this.initializeAdditionalMaterials();
      }
    }
  },

  computed: {
    baseUrl: function() {
      return process.env.VUE_APP_BASE_URI;
    },
    opportunityAdditionalMaterials: {
      get() {
        return this.$store.state.opportunityForm.opportunity
          .opportunityAdditionalMaterials;
      },
      set(value) {
        this.$store.commit("updateOpportunityAdditionalMaterials", value);
      }
    },

    // only show additional materials that match the selected type and category
    validAdditionalMaterials: function() {
      var additionalMaterialArray = [];
      var selectedOpportunityTypeId = this.$store.state.opportunityForm
        .opportunity.opportunityTypeId;
      var selectedOpportunityCategoryId = this.$store.state.opportunityForm
        .opportunity.opportunityCategoryId;
      _.forEach(this.additionalMaterials, function(additionalMaterial) {
        var foundMatch = _.find(
          additionalMaterial.additionalMaterialTypeOpportunityTypeOpportunityCategories,
          function(additionalMaterialTypeOpportunityTypeOpportunityCategory) {
            return (
              additionalMaterialTypeOpportunityTypeOpportunityCategory.opportunityTypeId ===
                selectedOpportunityTypeId &&
              additionalMaterialTypeOpportunityTypeOpportunityCategory.opportunityCategoryId ===
                selectedOpportunityCategoryId
            );
          }
        );
        if (foundMatch) {
          additionalMaterialArray.push(additionalMaterial);
        }
      });
      return additionalMaterialArray;
    }
  },

  methods: {
    initializeAdditionalMaterials: function() {
      var that = this;
      var defaultAdditionalMaterials = [];
      var selectedOpportunityTypeId = this.$store.state.opportunityForm
        .opportunity.opportunityTypeId;
      var selectedOpportunityCategoryId = this.$store.state.opportunityForm
        .opportunity.opportunityCategoryId;
      _.forEach(this.additionalMaterials, function(additionalMaterial) {
        var foundMatch = _.find(
          additionalMaterial.additionalMaterialTypeOpportunityTypeOpportunityCategories,
          function(additionalMaterialTypeOpportunityTypeOpportunityCategory) {
            return (
              additionalMaterialTypeOpportunityTypeOpportunityCategory.opportunityTypeId ===
                selectedOpportunityTypeId &&
              additionalMaterialTypeOpportunityTypeOpportunityCategory.opportunityCategoryId ===
                selectedOpportunityCategoryId
            );
          }
        );

        if (additionalMaterial.applyByDefault && foundMatch) {
          defaultAdditionalMaterials.push({
            additionalMaterialTypeId:
              additionalMaterial.additionalMaterialTypeId
          });
        }
      });
      this.opportunityAdditionalMaterials = defaultAdditionalMaterials;
    }
  },

  created() {
    if (
      !this.opportunity.opportunityId &&
      this.additionalMaterials.length > 0
    ) {
      this.initializeAdditionalMaterials();
    }
  }
};
</script>

<style scoped>
</style>
